export default "__VITE_ASSET__DsGQvwQc__"